import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import API from '@sesame/web-api';

import { Spinner } from 'src/components/Spinner';
import { ILoadState, IRack, IRackComponent, IComponent, ISalesorder } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import { RackOUComponents } from './RackOUComponents';
import { RackPortmap } from './RackPortmap';
import { makeSortedComponents, sortTree } from './rackUtils';
import { useAuth0 } from '@auth0/auth0-react';

export default function RackElevation() {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [rack, setRack] = useState<IRack>();
  const [componentTree, setComponentTree] = useState<IRackComponent>();
  const [rackId, setRackId] = useState(0);
  const [displayState, setDisplayState] = useState<ILoadState>(ILoadState.NEW);
  const [salesorder, setSalesorder] = useState('')
  const [imgUpdateKey, setImgUpdateKey] = useState(1);

  const getRack = (reqRackId: number) => {
    getAccessTokenSilently().then(authToken => {
    API.get(authToken, `/api/v1/rack/${reqRackId}`)
      .then(resp => {
        const newRack = resp.data as IRack;
        setRack(newRack);
        setRackId(newRack.rackId);
        getSalesorder(newRack.salesorderId);
        getComponents(newRack.rackId);
      })
      .catch(err => {
        setDisplayState(ILoadState.ERROR);
      });
    });
  }

  const getComponents = async (rackId: number) => {

    const authToken = await getAccessTokenSilently();
    const resp = await API.get(authToken, `/api/v1/rack/${rackId}/components`)
      .catch(err => {
        setDisplayState(ILoadState.ERROR);
      });
    const comps = makeSortedComponents(resp.data as IComponent[]);
    sortTree(comps);
    setComponentTree(comps);
    setTimeout(() => setImgUpdateKey(Date.now()), 100);
    setDisplayState(ILoadState.READY);
  }


  const getSalesorder = async (salesorderId: number) => {
    const authToken = await getAccessTokenSilently();
    const resp = await API.get(authToken, `/api/v1/salesorder/${salesorderId}`)
    const salesorder = resp.data as ISalesorder;
    setSalesorder(salesorder.salesorderRef);
  }

  const onElevationChange = (componentTree?: IRackComponent) => {
    setTimeout(() => setImgUpdateKey(Date.now()), 100);
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryRackId = parseInt(queryParams.get('rack') || '0');
    getRack(queryRackId);
  }, [getAccessTokenSilently]);

  if (displayState == ILoadState.ERROR) {
    return <div className="uk-container">
      <h2>Rack</h2>
      <p>Error loading rack</p>
    </div>
  }

  if (isLoading || displayState == ILoadState.NEW || displayState == ILoadState.LOADING || !rack) {
    return <div className="uk-container uk-align-center">
      <br />
      <br />
      <Spinner />
    </div>
  }

  return <div className="uk-container uk-width-1-1">
    <h1>Rack Management</h1>
    {rack.identifier} - {rack.bomPartNumber} : {rack.revision}
    <br />
    {rack.description}
    <br />
    Sales Order: <a href={`/editSalesOrder?salesorder=${rack.salesorderId}`}>{salesorder}</a>
    <br />
    <br />
    <div className="uk-width-1-1 rackPortmap">
      <RackPortmap rack={componentTree!} elevationUpdateKey={imgUpdateKey} />
    </div>
    <div data-uk-grid>
      <div className="uk-width-2-3">
        <RackOUComponents
          componentTree={componentTree!}
          onElevationChange={onElevationChange}
          elevationUpdateKey={imgUpdateKey} />
      </div>
      <div className="uk-width-expand@m">
        <img src={`/api/v1/rack/${rack.rackId}/elevation#key=${imgUpdateKey}`} />
      </div>
    </div>
  </div>
};
